import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavbarV2 from './navbar-v2';
import FooterV2 from './footer-v2';

export default function Licenses() {
  // Sayfa yüklendiğinde en üste scroll yap
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const licenses = [
    {
      name: 'React',
      version: '18.3.1',
      license: 'MIT',
      purpose: 'Kullanıcı arayüzü framework',
      author: 'Meta (Facebook)',
      url: 'https://reactjs.org'
    },
    {
      name: 'React Router',
      version: '6.26.2', 
      license: 'MIT',
      purpose: 'Sayfa yönlendirme ve navigasyon',
      author: 'Remix Software Inc.',
      url: 'https://reactrouter.com'
    },
    {
      name: 'Tailwind CSS',
      version: '3.4.13',
      license: 'MIT',
      purpose: 'CSS framework ve stil sistemi',
      author: 'Tailwind Labs',
      url: 'https://tailwindcss.com'
    },
    {
      name: 'React Icons',
      version: 'Latest',
      license: 'MIT',
      purpose: 'Icon kütüphanesi',
      author: 'React Icons Contributors',
      url: 'https://react-icons.github.io/react-icons'
    },
    {
      name: 'TypeScript',
      version: '4.9.5',
      license: 'Apache-2.0',
      purpose: 'Tip güvenli JavaScript geliştirme',
      author: 'Microsoft',
      url: 'https://www.typescriptlang.org'
    }
  ];

  return (
    <div className="bg-white">
      <NavbarV2 />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-gray-50 to-slate-50 py-16 pt-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Açık Kaynak Lisansları</h1>
            <p className="text-lg text-gray-600 mb-6">
              Projemizde kullandığımız açık kaynak kütüphaneler ve lisans bilgileri
            </p>
            <div className="flex items-center justify-center text-sm text-gray-500">
              <Link to="/" className="hover:text-red-500">Ana Sayfa</Link>
              <span className="mx-2">/</span>
              <span className="text-red-500">Açık Kaynak Lisansları</span>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="bg-white border rounded-xl p-8 shadow-sm">
              {/* Introduction */}
              <div className="mb-8 p-6 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-blue-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div>
                    <h3 className="font-semibold text-blue-800 mb-2">Açık Kaynak Teşekkürü</h3>
                    <p className="text-blue-700 text-sm">
                      Hatim Takip uygulaması, açık kaynak topluluğunun değerli katkıları sayesinde geliştirilmiştir. 
                      Aşağıda kullandığımız temel kütüphaneleri ve lisans bilgilerini bulabilirsiniz.
                    </p>
                  </div>
                </div>
              </div>

              {/* License Cards */}
              <div className="mb-12">
                <h2 className="text-2xl font-semibold text-gray-800 mb-6">Kullanılan Kütüphaneler</h2>
                <div className="grid lg:grid-cols-2 gap-6">
                  {licenses.map((lib, index) => (
                    <div key={index} className="bg-gray-50 rounded-xl p-6 border border-gray-200 hover:shadow-md transition-shadow">
                      <div className="flex items-start justify-between mb-4">
                        <div className="flex-1">
                          <h3 className="text-xl font-semibold text-gray-800 mb-1">{lib.name}</h3>
                          <p className="text-sm text-gray-600 mb-2">{lib.purpose}</p>
                          <p className="text-sm text-gray-500">Geliştirici: {lib.author}</p>
                        </div>
                        <div className="text-right">
                          <span className="inline-flex px-3 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full">
                            {lib.license}
                          </span>
                          {lib.version && (
                            <div className="text-xs text-gray-500 mt-1">v{lib.version}</div>
                          )}
                        </div>
                      </div>
                      
                      <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                        <a 
                          href={lib.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center text-blue-600 hover:text-blue-700 text-sm font-medium"
                        >
                          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                          </svg>
                          Proje Sayfası
                        </a>
                        <div className="text-xs text-gray-500">
                          Lisans: {lib.license}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* License Table */}
              <div className="mb-8">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Lisans Özet Tablosu</h3>
                <div className="overflow-x-auto rounded-lg border border-gray-200">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kütüphane</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Versiyon</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Lisans</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kullanım Amacı</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {licenses.map((lib, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="font-medium text-gray-900">{lib.name}</div>
                            <div className="text-sm text-gray-500">{lib.author}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                            {lib.version}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                              lib.license === 'MIT' 
                                ? 'bg-green-100 text-green-800' 
                                : lib.license === 'Apache-2.0'
                                ? 'bg-blue-100 text-blue-800'
                                : 'bg-gray-100 text-gray-800'
                            }`}>
                              {lib.license}
                            </span>
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-600">{lib.purpose}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* License Information */}
              <div className="space-y-8">
                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">Lisans Türleri</h2>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="bg-green-50 p-6 rounded-lg border border-green-200">
                      <h3 className="text-lg font-semibold text-green-800 mb-3">MIT Lisansı</h3>
                      <p className="text-green-700 text-sm mb-4">
                        En esnek açık kaynak lisanslarından biri. Ticari ve ticari olmayan kullanımla ilgili 
                        minimal kısıtlamalar içerir.
                      </p>
                      <div className="text-xs text-green-600">
                        <p><strong>İzin verilen:</strong> Ticari kullanım, değişiklik, dağıtım, özel kullanım</p>
                        <p><strong>Gereklilik:</strong> Telif hakkı ve lisans bildirimi dahil edilmeli</p>
                      </div>
                    </div>

                    <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
                      <h3 className="text-lg font-semibold text-blue-800 mb-3">Apache 2.0 Lisansı</h3>
                      <p className="text-blue-700 text-sm mb-4">
                        Patent koruması sağlayan, kurumsal kullanım için uygun açık kaynak lisansı.
                      </p>
                      <div className="text-xs text-blue-600">
                        <p><strong>İzin verilen:</strong> Ticari kullanım, değişiklik, dağıtım, patent kullanımı</p>
                        <p><strong>Gereklilik:</strong> Lisans ve telif hakkı bildirimi, değişiklik bildirimi</p>
                      </div>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">Uyumluluk Beyanı</h2>
                  <div className="text-gray-700">
                    <div className="bg-gray-50 p-6 rounded-lg">
                      <p className="mb-4">
                        Hatim Takip projesi olarak, kullandığımız tüm açık kaynak kütüphanelerin 
                        lisans koşullarına tam uyum göstermekteyiz:
                      </p>
                      <ul className="list-disc ml-6 space-y-2 text-sm">
                        <li>Tüm telif hakkı bildirimleri korunmuştur</li>
                        <li>Lisans metinleri uygun yerlerde gösterilmiştir</li>
                        <li>Değişiklikler uygun şekilde belgelenmiştir</li>
                        <li>Patent hakları korunmuştur</li>
                        <li>Kaynak kodu şeffaflık için paylaşılabilir durumdadır</li>
                      </ul>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">Tam Lisans Listesi</h2>
                  <div className="text-gray-700">
                    <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200">
                      <div className="flex items-start">
                        <svg className="w-6 h-6 text-yellow-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div>
                          <h3 className="font-semibold text-yellow-800 mb-2">Geliştirilmekte</h3>
                          <p className="text-yellow-700 text-sm">
                            Otomatik tam lisans listesi ve detaylı bağımlılık analizi gelecek güncellemelerde eklenecektir. 
                            Şu an manuel olarak temel kütüphaneleri listelemekteyiz.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">Lisans Sorunu Bildirimi</h2>
                  <div className="text-gray-700">
                    <p className="mb-4">
                      Herhangi bir lisans uyumsuzluğu fark ederseniz veya eksik bir bildirim tespit ederseniz, 
                      lütfen bizimle iletişime geçin:
                    </p>
                    <div className="bg-gray-50 p-6 rounded-lg">
                      <p className="font-medium mb-2">İletişim:</p>
                      <a 
                        href="mailto:gudersamet@gmail.com?subject=Lisans%20Sorunu%20Bildirimi" 
                        className="inline-flex items-center text-red-500 hover:text-red-600 font-medium"
                      >
                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                        </svg>
                        gudersamet@gmail.com
                      </a>
                    </div>
                  </div>
                </section>
              </div>

              {/* Related Pages */}
              <div className="mt-12 pt-8 border-t border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">İlgili Sayfalar</h3>
                <div className="grid md:grid-cols-3 gap-4">
                  <Link 
                    to="/privacy-policy" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Gizlilik Politikası</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Veri koruma ve gizlilik
                    </p>
                  </Link>
                  <Link 
                    to="/terms-of-service" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Kullanım Koşulları</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Yazılım kullanım kuralları
                    </p>
                  </Link>
                  <Link 
                    to="/support" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Destek</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Teknik yardım ve sorular
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterV2 />
    </div>
  );
}
